import { Button, Divider, Stack, Typography } from '@mui/material';

import { FormProvider, useForm, useFormContext } from 'react-hook-form';

import { useCollection, useUploadFile, useWrite } from 'ember';

import { cuid, useAuthData, DateTime } from 'stuff';

import SearchableSelectGizmo from 'app/gizmos/fields/select/SearchableSelectGizmo';

import ShortTextFieldGizmo from 'app/gizmos/fields/text/ShortTextFieldGizmo';

import { User } from 'types';

import { useCertification } from './CertificationDataProvider';
import { Certification } from 'models';
import { useCertificationRecord } from './CertificationRecordsProvider';




const CreateEditCertificationRecord = ({
	
	closeDialog,
	setCloseDialog,
} : {

	closeDialog?: boolean,
	setCloseDialog: React.Dispatch<React.SetStateAction<boolean>>,
}) =>

{
	const form = useFormContext();
	const { control } = form;
	
	const { claims } = useAuthData();
	
	const {assets,  users, current_certifications, handleSubmit } = useCertificationRecord()
	
	
	const current_user = {
		_id: claims?.user_id,
		name: claims?.name,
		email: claims?.email,
	};

	const form_options = [
		'Yes',
		'No'
	]

	const lead_time_in_days = [30, 60, 90]

	
	
	
	return (
			
			<Stack
				direction='column'
				alignItems='center'
				justifyContent='flex-start'
				width='100%'
				spacing={1}
			>
				<Typography
					variant='subtitle1'
				>
					Create a new Certificate
				</Typography>
				
				<Stack
					direction='column'
					justifyContent='flex-start'
					alignItems='flex-start'
					spacing={2}
				>
					
					<SearchableSelectGizmo
						name={'Assets'}
						label={'Select Asset'}
						help={'Select any assets that apply to this certification'}
						options={assets}
						getOptionLabel={(option) => option.name || ''}
						multiple={true}
						/>
					

					<SearchableSelectGizmo
						name={'Users'}
						label={'Select Users'}
						help={'Select any assets that apply to this certification'}
						options={users}
						getOptionLabel={(option) => option.name || ''}
						multiple={true}	
						/>
					
					<SearchableSelectGizmo
						name={'category'}
						label={'Certification Category'}
						help={'Select which Category it belongs to'}
						options={current_certifications}
						getOptionLabel={(option) => option.category || ''}
						freeSolo={true}
						multiple={false}
					/>
					
					
					
				</Stack>
				
				
				
				<Stack
					direction='row'
					width='100%'
					justifyContent='center'
					alignItems='center'
				>
						<Button
							variant='contained'
							onClick={handleSubmit}
							type='submit'	
							
						>
							Create
						</Button>
				</Stack>
				
				
			</Stack>
			
	)
}


export default CreateEditCertificationRecord